// extracted by mini-css-extract-plugin
export var createdDate = "_n6-1";
export var divider = "_n6-2";
export var headerDivider = "_n6-3";
export var messagesCard = "_n6-0";
export var messagesContainer = "_n6-7";
export var messagesContainerWrapper = "_n6-4";
export var pointerCapturingButtonBoxes = "_n6-a";
export var showLeftPanelButton = "_n6-9";
export var showMoreButton = "_n6-c";
export var showMoreButtonContainer = "_n6-b";
export var summaryTitle = "_n6-6";
export var systemMessageCardWrapper = "_n6-d";
export var topButtons = "_n6-8";
export var withPadding = "_n6-5";